module.exports = __webpack_public_path__ + "img/WX.155e0ba2.png";